/**
 * Xingyu Video Reels — estilo Approve
 * O grupo fica fixo e centralizado; só o vídeo do meio muda (rotação dos cards).
 * Sem translate/scroll da faixa para os lados.
 */
(function () {
  function initReels(root) {
    if (root.dataset.xyReelsReady === '1') return;
    root.dataset.xyReelsReady = '1';

    var track = root.querySelector('[data-xy-reels-track]');
    if (!track) return;

    var intervalMs = parseInt(root.getAttribute('data-autoplay-ms'), 10) || 3500;
    var direction = 1;
    var timer = null;

    function cards() {
      return Array.prototype.slice.call(track.querySelectorAll('[data-xy-reels-card]'));
    }

    function playVideos() {
      track.querySelectorAll('video').forEach(function (video) {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      });
    }

    /** Active = always the physical middle card. */
    function markCenterActive() {
      var list = cards();
      if (!list.length) return;
      var mid = Math.floor(list.length / 2);
      list.forEach(function (card, i) {
        card.classList.toggle('is-active', i === mid);
      });
    }

    function stepForward() {
      var first = track.firstElementChild;
      if (!first) return;
      track.appendChild(first);
      markCenterActive();
      playVideos();
    }

    function stepBackward() {
      var last = track.lastElementChild;
      if (!last) return;
      track.insertBefore(last, track.firstElementChild);
      markCenterActive();
      playVideos();
    }

    function step() {
      if (document.hidden) return;
      var list = cards();
      if (list.length < 2) return;

      if (direction > 0) {
        stepForward();
      } else {
        stepBackward();
      }

      // Ping-pong: after a full pass of all cards, reverse direction
      root._xyReelsSteps = (root._xyReelsSteps || 0) + 1;
      if (root._xyReelsSteps >= list.length - 1) {
        root._xyReelsSteps = 0;
        direction *= -1;
      }
    }

    function startTimer() {
      stopTimer();
      if (cards().length < 2) return;
      timer = window.setInterval(step, intervalMs);
    }

    function stopTimer() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    // Click a side card → rotate until it sits in the center
    track.addEventListener('click', function (e) {
      var card = e.target.closest('[data-xy-reels-card]');
      if (!card || !track.contains(card)) return;

      var list = cards();
      var mid = Math.floor(list.length / 2);
      var from = list.indexOf(card);
      if (from < 0 || from === mid) return;

      var diff = from - mid;
      if (diff > 0) {
        for (var i = 0; i < diff; i++) stepForward();
        direction = 1;
      } else {
        for (var j = 0; j < -diff; j++) stepBackward();
        direction = -1;
      }
      root._xyReelsSteps = 0;
      startTimer();
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopTimer();
      } else {
        markCenterActive();
        playVideos();
        startTimer();
      }
    });

    markCenterActive();
    playVideos();
    startTimer();

    document.addEventListener(
      'touchstart',
      function once() {
        playVideos();
        document.removeEventListener('touchstart', once);
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-xy-reels]').forEach(initReels);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target && e.target.querySelector
      ? e.target.querySelector('[data-xy-reels]') || (e.target.matches && e.target.matches('[data-xy-reels]') ? e.target : null)
      : null;
    if (section) {
      section.dataset.xyReelsReady = '';
      initReels(section);
    } else {
      boot();
    }
  });
})();
